import { FormSelect } from 'core/components/common/FormSelect'
import { UtilisateurSelectOption } from 'lauria/hooks/useUtilisateurMultiSelect'
import React, { ChangeEvent } from 'react'
import { FieldError } from 'react-hook-form'

type UtilisateurMultiSelectProps = {
  placeholder: string
  fieldName: string
  options: UtilisateurSelectOption[]
  isLoading: boolean
  value: string
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
  displayDefaultOption?: boolean
  width?: string
  error?: FieldError
}

export const UtilisateurMultiSelect: React.FC<UtilisateurMultiSelectProps> = ({
  placeholder,
  fieldName,
  options,
  isLoading,
  value,
  onChange,
  displayDefaultOption = true,
  width = '[300px]',
  error,
}) => {
  return (
    <div className="md:flex md:flex-col">
      <FormSelect
        placeholder={placeholder}
        options={options}
        fieldName={fieldName}
        wrapperClassName={`md:w-${width}`}
        wrapperErrorClassName="h-[0px]"
        onChange={onChange}
        isLoading={isLoading}
        value={value}
        displayDefaultOption={displayDefaultOption}
        error={error}
      />
    </div>
  )
}
